export default __webpack_public_path__ + "static/media/no_profile_pic.aae80c57.png";